import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Fri Feb 19 2021
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { Inject } from '@logio/typescript-ioc';
import { jsonConversions, PromotionSplitDTOConverter } from '@logio/common-be-fe';
import { CONSTANTS } from '../../../constants';
import logger from '../../logger';
import api from '../../api';
import { List } from 'immutable';
/**
 * @author Tomas Leity
 */

export var PromotionSplitLayer =
/*#__PURE__*/
function () {
  function PromotionSplitLayer() {
    var _this = this;

    _classCallCheck(this, PromotionSplitLayer);

    /**
     * Returns splits based on split option
     *
     * @param promotionIds List of {@link Promotion} ids
     * @param splitOption Find splits for this category
     */
    this.findSplits = function (promotionIds, splitOption) {
      var apiConfig = {
        responseType: 'json'
      };
      return api(CONSTANTS.API.ENDPOINTS.PROMOTIONS_SPLITS).post({
        promotionIds: promotionIds.toArray(),
        splitOption: splitOption
      }, apiConfig).then(function (response) {
        return List((response.data.result || []).map(function (item) {
          return _this.getConverter().toObject(item, jsonConversions);
        }));
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
  }

  _createClass(PromotionSplitLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
  }]);

  return PromotionSplitLayer;
}();

__decorate([Inject, __metadata("design:type", PromotionSplitDTOConverter)], PromotionSplitLayer.prototype, "converter", void 0);